import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DashboardStatResponse } from 'signature-public-api-sdk';

import { StatsState } from './stats-types';

const initialState: StatsState = {
    commission: {
        current: {
            year: 0,
            month: 0,
        },
        previous: {
            year: 0,
            month: 0,
        },
    },
    stages: {
        consultation: 0,
        awaitingCustomer: 0,
        processing: 0,
        underwriting: 0,
        offer: 0,
        hold: 0,
        completed: 0,
        cancelled: 0,
    },
};

const slice = createSlice({
    name: 'stat',
    initialState: initialState as StatsState,
    reducers: {
        receiveStatsSuccess: (state, action: PayloadAction<DashboardStatResponse>) => ({
            ...state,
            commission: action.payload.commission,
            stages: action.payload.stages,
        }),
    },
});

export const { actions, name, reducer } = slice;
export const { receiveStatsSuccess } = actions;
export default slice;
